export default {"src":"/_next/static/media/wrench_24.c3a7fcf4.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};